import { render } from "./AutomationWizardTaskReminder.vue?vue&type=template&id=deace4b0&scoped=true"
import script from "./AutomationWizardTaskReminder.vue?vue&type=script&lang=js"
export * from "./AutomationWizardTaskReminder.vue?vue&type=script&lang=js"

import "./AutomationWizardTaskReminder.vue?vue&type=style&index=0&id=deace4b0&scoped=true&lang=scss"
import "./AutomationWizardTaskReminder.vue?vue&type=style&index=1&id=deace4b0&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deace4b0"]])

export default __exports__